import { createFileRoute } from '@tanstack/react-router';
import BannedEmployees from '@/features/banned-employees';

export const Route = createFileRoute('/_authenticated/banned-employees')({
  component: () => <BannedEmployees />,
}); 